import React from 'react';
import sneakerImage from '../../../public/static/images/rat-race/sneaker.png';
import tracksuitImage from '../../../public/static/images/rat-race/tracksuit.jpg';
import jeffImage from '../../../public/static/images/rat-race/Jeff.png';
import underwearRatImage from '../../../public/static/images/rat-race/underwearRat.png';
import bananaRatImage from '../../../public/static/images/rat-race/bananaRat.png';
import useMobileCarousel from '../hooks/useMobileCarousel';
import styles from './index.module.scss';

const getAssetSrc = (asset) => asset?.src || asset;

const HOW_IT_WORKS_STEPS = [
  {
    key: 'goal',
    kind: 'sneaker',
    title: 'Set Your Daily Step Count Goal.',
    body: 'Pick the number that fits your routine.',
  },
  {
    key: 'walk',
    kind: 'image',
    image: tracksuitImage,
    alt: 'Tracksuit rat',
    title: 'Take A Walk With Your Rat',
    body: 'Wherever you scurry, your rat bestie is right there, cheering you on.',
  },
  {
    key: 'leaderboard',
    kind: 'leaderboard',
    image: jeffImage,
    alt: 'Jeff',
    title: 'Keep Momentum. Climb The Leaderboard',
    body: 'Keep your streak alive and make your way up the leaderboard.',
  },
  {
    key: 'cheddar',
    kind: 'image',
    image: underwearRatImage,
    alt: 'Underwear rat',
    title: 'Earn Rewards For Your Rat With Cheddar',
    body: 'Every step earns Cheddar. Spend it on outfits, accessories, and rest days that can save your streak.',
  },
  {
    key: 'customize',
    kind: 'image',
    image: bananaRatImage,
    alt: 'Banana rat',
    title: "Customize Your Rat's Outfit",
    body: 'Upload a photo of an outfit, dress your rat, then show your bestie off on the leaderboard.',
  },
];

function StepVisual({ step }) {
  if (step.kind === 'sneaker') {
    return (
      <div className={styles.howItWorksSneakerVisual}>
        <img
          className={styles.howItWorksSneakerImage}
          src={getAssetSrc(sneakerImage)}
          alt="Sneaker"
        />
        <div className={styles.howItWorksSneakerProgressTrack} />
        <div className={styles.howItWorksSneakerProgressThumb} />
        <span
          className={`${styles.howItWorksSneakerProgressLabel} ${styles.howItWorksSneakerProgressLabelStart}`}
        >
          1K
        </span>
        <span
          className={`${styles.howItWorksSneakerProgressLabel} ${styles.howItWorksSneakerProgressLabelMiddle}`}
        >
          10K
        </span>
        <span
          className={`${styles.howItWorksSneakerProgressLabel} ${styles.howItWorksSneakerProgressLabelEnd}`}
        >
          25K
        </span>
      </div>
    );
  }

  return (
    <div className={styles.howItWorksStepImageArea}>
      <img
        className={styles.howItWorksStepCornerImage}
        src={getAssetSrc(step.image)}
        alt={step.alt}
      />
    </div>
  );
}

function StepCard({ step, className, style }) {
  return (
    <div className={className} style={style}>
      <StepVisual step={step} />
      <h3 className={styles.howItWorksStepTitle}>{step.title}</h3>
      <p className={styles.howItWorksStepBody}>{step.body}</p>
    </div>
  );
}

export default function RatRaceHowItWorks() {
  const { activeSlide, setActiveSlide, handleTouchStart, handleTouchEnd } =
    useMobileCarousel(HOW_IT_WORKS_STEPS.length);

  return (
    <section className={styles.howItWorksSection}>
      <div className={styles.howItWorksInner}>
        <div className={styles.howItWorksTitleWrap}>
          <h2 className={styles.howItWorksTitle}>How it works.</h2>
        </div>
        <div className={styles.howItWorksStepsContainer}>
          {HOW_IT_WORKS_STEPS.map((step) => (
            <StepCard
              key={step.key}
              step={step}
              className={styles.howItWorksStep}
            />
          ))}
        </div>
        <div className={styles.howItWorksMobileCarousel}>
          <div
            className={styles.howItWorksMobileViewport}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <div
              className={styles.howItWorksMobileTrack}
              style={{ transform: `translateX(-${activeSlide * 100}%)` }}
            >
              {HOW_IT_WORKS_STEPS.map((step, index) => (
                <StepCard
                  key={step.key}
                  step={step}
                  className={styles.howItWorksMobileStep}
                  style={{ opacity: index === activeSlide ? 1 : 0.4 }}
                />
              ))}
            </div>
          </div>
          <div className={styles.howItWorksMobileDots}>
            {HOW_IT_WORKS_STEPS.map((step, index) => (
              <button
                key={step.key}
                type="button"
                className={`${styles.howItWorksMobileDot} ${index === activeSlide ? styles.howItWorksMobileDotActive : ''
                  }`}
                onClick={() => setActiveSlide(index)}
                aria-label={`Show step ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
